import React, { Component } from 'react';
import { Link } from 'react-router-dom'


import author from '../../assets/img/people/4.jpg';
import advimg from '../../assets/img/blog/details/5.jpg';
// Categories
const categories = [
    { title: 'Slate & Crystal Events' },
    { title: 'Indigo Event Planning' },
    { title: 'Buttercup Events' },
    { title: 'Done Right Event Designs' },
    { title: 'Polished Events' },
    { title: 'Posh Peony Events' },
    { title: 'Dark Roast Events' },
    { title: 'Origami Crane Wedding Planners' },
];
// Popular Tags
const tags = [
    { tag: 'Isabella' },
    { tag: 'Samantha' },
    { tag: 'Emily' },
    { tag: 'June' },
    { tag: 'Grace' },
    { tag: 'Madison' },
    { tag: 'Heather' },
    { tag: 'Micheal' },
];


class Blogsidebar extends Component {
    render() {
        return (
            <div className="sidebar">
                {/* About Author Start */}
                <div className="sidebar-widget widget-about-author">
                    <div className="widget-about-author-inner">
                        <img src={author} alt="" />
                        <h5>About Me</h5>
                        <p>"Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Donec sollicitudin molestie
        malesuada. Mauris blandit aliquet elit"</p>
                        <Link to="/blog-details">Johny Bora</Link>
                    </div>
                </div>
                {/* About Author End */}
                {/* Search Widget Start */}
                <div className="sidebar-widget widget-search">
                    <h5 className="widget-title">Search</h5>
                    <form method="post">
                        <div className="sigma_search-adv-input">
                            <input type="text" className="form-control" placeholder="Search Posts" name="search" />
                            <button type="submit" name="button"><i className="fa fa-search" /></button>
                        </div>
                    </form>
                </div>
                {/* Search Widget End */}
                {/* Categories Start */}
                <div className="sidebar-widget">
                    <h5 className="widget-title"> Our Categories </h5>
                    <ul className="sidebar-widget-list">
                        {categories.map((item, i) => (
                            <li key={i}>
                                <Link to="/blog-details"> {item.title} </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                {/* Categories End */}
                {/* Popular Tags Start */}
                <div className="sidebar-widget">
                    <h5 className="widget-title">Popular Tags</h5>
                    <div className="tagcloud">
                        {tags.map((item, i) => (
                            <Link to="/blog-details" key={i}>{item.tag}</Link>
                        ))}
                    </div>
                </div>
                {/* Popular Tags End */}
                {/* Ad banner Start */}
                <div className="sidebar-widget widget-ad p-0 border-0">
                    <Link to="/">
                        <img src={advimg} alt="" />
                    </Link>
                </div>
                {/* Ad banner End */}
            </div>
        );
    }
}

export default Blogsidebar;